<template>
  <FocusLock
    :disabled="noFocusLock"
    class="dialog dialog-template"
    :class="{ 'focusLock-full': dataDialog.full }"
  >
    <v-btn
      v-if="dataDialog.full"
      icon
      class="dialog_closeIcon"
      taborder="99"
      @click="closeDialog"
    >
      <span v-if="dataDialog.btnCloseOutside" class="icon icon-close" />
    </v-btn>
    <div v-if="!dataDialog.full" class="dialog_container">
      <div v-if="dataDialog.title" class="dialog_title">
        <span>{{ dataDialog.title }}</span>
        <v-btn icon class="dialog_closeIcon" @click="closeDialog">
          <span v-if="dataDialog.btnCloseOutside" class="icon icon-close" />
        </v-btn>
      </div>
      <div class="dialog_content">
        <component
          :is="!dataDialog.text && dataDialog.namecomponent"
          v-bind="dataDialog.props"
          @close="close"
        />
      </div>
    </div>
    <component
      :is="dataDialog.namecomponent"
      v-if="!dataDialog.text && dataDialog.full"
      v-bind="dataDialog.props"
      @close="close"
    />
  </FocusLock>
</template>
<script>
import { dialogService } from '@/services/dialog.service';
// const FocusLock = require('vue-focus-lock').default;
import { mapGetters } from 'vuex';
const Lock = require('vue-focus-lock').default;

export default {
  name: 'DialogTemplate',
  components: {
    FocusLock: Lock,
  },
  props: {
    dataDialog: {
      type: Object,
      default: () => {},
    },
    full: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    noFocusLock: false,
    dialogNames: undefined,
  }),
  computed: {
    ...mapGetters('dialog', {
      dialog: 'nameDialogs',
    }),
  },
  watch: {
    dialog: [
      {
        handler: 'isNameDialogsChange',
        immediate: true,
        deep: true,
      },
    ],
  },
  mounted() {},
  methods: {
    isNameDialogsChange(newValue) {
      if (
        this.dataDialog.namecomponent.name !== newValue[newValue.length - 1]
      ) {
        this.noFocusLock = true;
      } else {
        this.noFocusLock = false;
      }
    },
    close(data) {
      dialogService.close(this.dataDialog.namecomponent.name);
      if (typeof this.dataDialog.eventReturnData === 'function') {
        this.dataDialog.eventReturnData(data);
      }
      this.$emit('close');
    },
    closeDialog() {
      if (this.dataDialog.isConfirmedDialogClose) {
        this.noFocusLock = true;
        dialogService.showConfirmDialog(
          {
            title: '確認',
            content:
              'OKボタンをクリックすると、入力した内容が破棄されますが宜しいですか？',
            cancel: true,
            ok: true,
          },
          {
            classes: ['v--modal', 'ConfirmDialog'],
          },
          (payload) => {
            if (payload) {
              dialogService.close(this.dataDialog.namecomponent.name);
              if (typeof this.dataDialog.eventReturnData === 'function') {
                this.dataDialog.eventReturnData(null);
              }
              this.$emit('close');
            }
            setTimeout(() => {
              this.noFocusLock = false;
            });
          }
        );
      } else {
        dialogService.close(this.dataDialog.namecomponent.name);
        if (typeof this.dataDialog.eventReturnData === 'function') {
          this.dataDialog.eventReturnData(null);
        }
        this.$emit('close');
      }
    },
  },
};
</script>
<style lang="scss">
.focusLock {
  height: 100%;
}
.dialog_container {
  height: 100%;
  min-height: 390px;
  max-height: calc(100vh - 100px);
}
</style>
